'use client'

import { type PubmedArticleType } from '@components/app/ListingPage/TrialResearchFindingsSection'
import ArticleWithFinding from '@components/app/ListingPage/TrialResearchFindingsSection/ArticleWithFinding'
import { Icon } from '@components/primitives/Icon'
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown'
import { faChevronUp } from '@fortawesome/pro-regular-svg-icons/faChevronUp'
import { useState } from 'react'

const MoreArticles = ({ articles }: { articles: PubmedArticleType[] }) => {
  const [extraArticlesHidden, setExtraArticlesHidden] = useState(true)

  if (articles.length === 0) return <></>

  return (
    <>
      {articles.map((article) => (
        <ArticleWithFinding
          article={article}
          hidden={extraArticlesHidden}
          key={article.pmId}
        />
      ))}

      <button
        className='flex cursor-pointer items-center gap-2 pt-2 text-base text-primary500'
        onClick={() => setExtraArticlesHidden((e) => !e)}
      >
        {extraArticlesHidden ? (
          <>
            {`See ${articles.length} more`}
            <Icon icon={faChevronDown} />
          </>
        ) : (
          <>
            See less
            <Icon icon={faChevronUp} />
          </>
        )}
      </button>
    </>
  )
}

export default MoreArticles
